import React, { Component } from 'react';
import { Modal, message } from 'antd';
import FormList from '../../basicElement/FormList';
import Fetch from "../../../common/Fetch";
import API_URL from '../../../common/url';
import fp from '../../../utils/fp';

class Update extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
        directAreaOptions: [],
    }

    show = (record, type) => {
        const { directAreaList } = this.props;
        const directAreaOptions = fp.map(i => ({
            value: i.areaId,
            label: i.areaName,
        }))(directAreaList);
        let data;
        if (type === 'add') {
            const directAreaOption = directAreaOptions[0];
            data = {
                areaId: directAreaOption.value,
                areaName: directAreaOption.label,
            };
        } else {
            const { provinceIds } = record;
            data = {
                ...record,
                regions: (provinceIds || '').split(','),
            };
        }
        this.setState({
            data,
            type,
            visible: true,
            directAreaOptions,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        if (key === 'userName') {
            const { text: userName, value: userId } = value;
            data.userId = userId;
            data.userName = userName;
        } else {
            data[key] = value; 
        }
        this.setState({ data });
    }

    getColumns = () => {
        const { areaList } = this.props;
        const { type, data, directAreaOptions } = this.state;
        const { areaId } = data;
        const canEdit = type === 'edit';
        const regionOptions = fp.compose(
            fp.map(i => ({ value: i.regionId, label: i.regionName })),
            fp.defValue([]),
            fp.prop('regions'),
            fp.defValue({}),
            fp.find(fp.propEq('value', +areaId))
        )(areaList);

        // 字段属性配置
        const columns = [{
            name: '区域',
            key: 'areaId',
            type: 'select',
            typeProperty: {
                disabled: canEdit,
                style: { width: 200 },
                list: directAreaOptions,
            },
            rules: {
                required: true,
            }
        }, {
            name: '带教组长',
            key: 'userName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyWord',
                style: { width: 200 },
                disabled: canEdit,
                placeholder: '输入姓名/工号检索',
                params: { limit: 20, roleCodes: 'CRC,CRCC,CRCM' },
                url: API_URL.teaching.queryEmpListByRoleCode,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            },
            rules: {
                required: true,
            },
        }, {
            name: '分管省份',
            key: 'regions',
            type: 'select',
            typeProperty: {
                mode: 'multiple',
                style: { width: 200 },
                list: regionOptions,
            },
            rules: {
                required: true,
            }
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;
        const { userId, areaId, teachLeaderId, regions } = data;
        const params = {};
        regions.forEach((o, i) => params[`ids[${i}]`] = o);
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.saveTeachLeader, {
            teachLeaderId,
            userId,
            areaId,
            ...params,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible, type } = this.state;
        const title = (type === 'add' && '添加带教组长') || (type === 'edit' && '修改带教组长');
        return (
            <Modal
                title={title}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="460px"
            >
                <FormList
                    className="form-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
            </Modal>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/director/Update.js